import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    faqs: {},
    selectedFaqId:"",
    faq:{}
};


const payroll = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_PAYROLL_LIST: {
      draft.payroll = payload?.payroll;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default payroll;
